import { configureStore } from '@reduxjs/toolkit'
import currentUser from '../reducers/currentUser'
import companyTalent from "../reducers/companyTalent";
import companyStaff from '../reducers/companyStaff';
import companyContent from '../reducers/companyContent';
import companyContentManage from '../reducers/companyContentManage';
import companyJob from '../reducers/companyJob';
import talentRegister from "../reducers/talentRegister";
import talentMypage from "../reducers/talentMypage";
import companyHome from '../reducers/companyHome';
import chatMessage from "../reducers/chatMessage";
import talentJob from "../reducers/talentJob";
import action from "../reducers/action";
import talentHome from "../reducers/talentHome";
import talentNotification from "../reducers/talentNotification";
import companyHistory from "../reducers/companyHistory";
import superUser from "../reducers/superUser";
import customerCompany from "../reducers/customerCompany";
import bulkMessages from "../reducers/bulkMessages";
import talentTag from "../reducers/talentTag";
import talentRegisterLink from "../reducers/talentRegisterLink";
import app from "../reducers/app";
import friendInvitation from "../reducers/friendInvitation";

const store = configureStore({
  reducer: {
    app,
    currentUser,
    companyTalent,
    companyStaff,
    companyContent,
    companyContentManage,
    companyJob,
    talentRegister,
    companyHome,
    chatMessage,
    talentJob,
    talentMypage,
    action,
    talentHome,
    talentNotification,
    companyHistory,
    superUser,
    customerCompany,
    bulkMessages,
    talentTag,
    talentRegisterLink,
    friendInvitation
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
})

export default store
